// 初始化左侧菜单
const initHelpMetisMenu = () => {
    $('#help-side-menu').metisMenu({toggle: false}).removeClass('hide');
};

const initHelpActiveMenu = () => {
    $('#help-sidebar-menu a').each((index: number, ele: HTMLElement) => {
        const pageUrl = window.location.pathname;
        if ($(ele).attr('href') == pageUrl) {
            $(ele).addClass('active');
            $(ele).parent().addClass('mm-active');
            $(ele).parent().parent().addClass('mm-show');
            $(ele).parent().parent().prev().addClass('mm-active');
            $(ele).parent().parent().parent().addClass('mm-active');
            $(ele).parent().parent().parent().parent().addClass('mm-show');
            $(ele).parent().parent().parent().parent().parent().addClass('mm-active');
        }
    });
};

const initHelpMenuItem = () => {
    $('.navbar-nav a').each((ele: HTMLElement) => {
        const pageUrl = window.location.href.split(/[?#]/)[0];
        if ( $(ele).href == pageUrl) {
            $(ele).addClass('active');
            $(ele).parent().addClass('active');
            $(ele).parent().parent().addClass('active');
            $(ele).parent().parent().parent().addClass('active');
            $(ele).parent().parent().parent().parent().addClass('active');
            $(ele).parent().parent().parent().parent().parent().addClass('active');
        }
    });
};

const initHelpMenuItemScroll = () => {
    $(document).ready(() =>{
        if($('#help-sidebar-menu').length > 0 && $('#help-sidebar-menu .mm-active .active').length > 0){
            let activeMenu = $('#help-sidebar-menu .mm-active .active').offset().top;
            if( activeMenu > 300) {
                activeMenu = activeMenu - 300;
                $('.vertical-menu .simplebar-content-wrapper').animate({ scrollTop: activeMenu }, 'slow');
            }
        }
    });
};

const updateHelpMenu = () => {
    const elements = document.getElementById('topnav-menu-content').getElementsByTagName('a');
    for(let i = 0, len = elements.length; i < len; i++) {
        if(elements[i].parentElement.getAttribute('class') === 'nav-item dropdown active') {
            elements[i].parentElement.classList.remove('active');
            elements[i].nextElementSibling.classList.remove('show');
        }
    }
};

const showHelpScroll = () => {
    $('.scroll').show();

    const scroll = $('.content-box').scrollTop();

    if (scroll >= 50) {
        $('.scroll').css({ opacity: 1, bottom: '60px', display: 'block' });
    } else {
        $('.scroll').css({ opacity: 0, bottom: '50px', display: 'none' });
    }
};

const helpScroll = () => {
    $('html, body').scroll(showHelpScroll);
};

(window as any).goTop = () => {
    $('html, body').animate({ scrollTop: 0 });
};
(window as any).goBottom = () => {
    $('html, body').animate({ scrollTop: document.body.scrollHeight });
};

const initHelp = () => {
    initHelpMetisMenu();
    initHelpActiveMenu();
    initHelpMenuItem();
    initHelpMenuItemScroll();
    showHelpScroll();
    helpScroll();
}

initHelp();